import { Stack, Typography } from '@mui/material';
import { RadioButtons } from 'Components/RadioButtons';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { NEW_PAGE_THOUGHTS, THOUGHTS } from 'Enum/Feedback';
import { useDictionary } from 'Hooks';

interface IThoughts {
  thoughtsValue: THOUGHTS | NEW_PAGE_THOUGHTS | '';
  setThoughtsValue: (value: THOUGHTS | NEW_PAGE_THOUGHTS | '') => void;
  options: string[];
}

export const Thoughts = ({
  thoughtsValue,
  setThoughtsValue,
  options,
}: IThoughts) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Feedback);

  return (
    <Stack
      sx={{
        gap: '24px',
        width: 'fit-content',
      }}
    >
      <Typography
        id='your-thoughts-label'
        variant='body2'
        sx={{
          maxWidth: '600px',
        }}
      >
        {window.location.pathname === '/'
          ? dictionary.whatDidYouThinkSite
          : dictionary.whatDidYouThinkPage}
      </Typography>
      <RadioButtons
        options={options}
        setValue={(value) => setThoughtsValue(value as THOUGHTS | '')}
        value={thoughtsValue}
        labelledby='your-thoughts-label'
      />
    </Stack>
  );
};
